import { configureStore, combineReducers } from "@reduxjs/toolkit";
import asyncJobsReducer from "./asyncJobs";

const rootReducer = combineReducers({
  asyncJobs: asyncJobsReducer,
});

// Define RootState based on the combineReducers result
export type RootState = ReturnType<typeof rootReducer>;

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    // Enable Redux DevTools in development
    devTools: process.env.NODE_ENV !== "production",
  });
};

export const store = setupStore();

// Additional type exports
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
